import React from 'react';
import { cn } from '@/utils';

const statusColors = {
  alert: 'bg-red-500',
  warning: 'bg-yellow-500',
  success: 'bg-green-500',
  neutral: 'bg-brand-light-100',
};

export default function ProgressBar({
  value,
  status = 'neutral',
  orientation = 'horizontal'
}: {
  value: number;
  status?: keyof typeof statusColors;
  orientation?: 'horizontal' | 'vertical';
}) {
  const style = orientation === 'horizontal' ? { width: value + '%'} : { height: value + '%' };
  return (
    <div className={cn(
      "dark:bg-gray-75 overflow-hidden rounded-full bg-brand-dark-100", {
        "w-full": orientation === 'horizontal',
        "h-full w-1 flex flex-col-reverse": orientation === 'vertical',
      }
    )}>
      <div
        className={cn(statusColors[status], {
          'h-1': orientation === 'horizontal',
          'w-1': orientation === 'vertical',
        })}
        style={style}
      ></div>
    </div>
  );
}
